export default "__VITE_ASSET__CjJ39Sk4__"